export default __webpack_public_path__ + "static/media/pattern_top.0f56f581.png";